export default __webpack_public_path__ + "static/media/languages.d29dd101.gif";